module.exports = __webpack_public_path__ + "static/media/IAP_WholeSale@3x.1f88c53d.png";